import React from "react";
import Heading from "@/components/elements/Heading";
import { Inertia } from "@inertiajs/inertia";
import { getHeaders } from "@/services/api";

/**
 * ChoicesScreen component that displays a list of selectable options
 * Renders choices in a table format with clickable links and navigation arrows
 * Used for presenting user choices like panel types, materials, etc.
 *
 * @param {Object} props - Component props
 * @param {Array} props.choices - Array of choice objects with name, link, and nextlink properties
 * @param {string} props.heading - Main heading text to display above the choices
 */
const ChoicesScreen = ({ choices, heading }) => {

    /**
     * Handle choice selection and navigation
     * Makes a PUT request to update the selection and navigate to the next step
     *
     * @param {Event} e - Click event
     * @param {string} link - API endpoint to update the choice
     * @param {string} nextlink - URL to navigate to after successful update
     */
    function pickPanel(e, link, nextlink) {
        e.preventDefault();

        Inertia.put(link, { nextlink: nextlink }, {headers: getHeaders()});
    }

    return (
        <>
            <Heading heading={heading} />
            <table className="w-100 choicetable">
                <tbody>
                    {choices.map((choice, key) => (
                        <tr key={key}>
                            <td>
                                <a
                                    onClick={(e) =>
                                        pickPanel(
                                            e,
                                            choice.link,
                                            choice.nextlink,
                                        )
                                    }
                                    className="step"
                                    href="#"
                                >
                                    {choice.name}
                                </a>
                            </td>

                            {/* Navigation arrow icon */}
                            <td>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 448 512"
                                    width="16"
                                >
                                    {/* Right arrow path */}
                                    <path d="M216.464 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L387.887 239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h375.887L209.393 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L233.434 36.465c-4.686-4.687-12.284-4.687-16.97 0z" />
                                </svg>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
};

export default ChoicesScreen;
